import { useLocation } from 'react-router-dom';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  }

  return ComponentWithRouterProp;
}
